import { Component } from '@angular/core';

@Component({
  selector: 'app-restricted-access',
  templateUrl: './restricted-access.component.html',
  styleUrl: './restricted-access.component.css'
})
export class RestrictedAccessComponent {

}
